export default __webpack_public_path__ + "static/media/simbolo_ok.8edd2bcf.svg";